// Admin UI translations — Thai + Australian English.
export const ADMIN_LANGS = [
  { id: 'th', label: 'ไทย' },
  { id: 'en', label: 'EN' },
]

export const ADMIN_I18N = {
  th: {
    // login
    loginTitle: 'หลังบ้าน Level Up Glass Supply',
    loginPassword: 'รหัสผ่าน (ADMIN_KEY)',
    loginWrong: 'รหัสไม่ถูกต้อง',
    loginButton: 'เข้าสู่ระบบ',
    logout: 'ออกจากระบบ',
    // tabs
    tabOrders: 'ออเดอร์',
    tabProducts: 'สินค้า',
    tabSettings: 'ตั้งค่าร้าน',
    loading: 'กำลังโหลด…',
    // order statuses
    stAwaiting: 'รอชำระเงิน',
    stReview: 'ลูกค้าแจ้งโอนแล้ว — รอตรวจ',
    stPaid: 'รับเงินแล้ว',
    stFulfilled: 'ส่งมอบแล้ว',
    stCancelled: 'ยกเลิก',
    // delivery
    dvPickup: 'รับเอง (Ravenhall)',
    dvDelivery: 'จัดส่ง (รัศมี 50 กม.)',
    pmCard: '💳 จ่ายผ่านบัตร (Stripe)',
    pmBank: '🏦 โอนธนาคาร',
    pmCash: '💵 เงินสดตอนมารับ',
    pickupBy: (d) => `ลูกค้าต้องมารับภายใน ${d}`,
    pickupLate: 'เลยกำหนดรับ',
    fCashEnabled: 'เปิดให้จ่ายเงินสดตอนมารับของ',
    fCashEnabledHint: 'โชว์ตัวเลือก "Cash on pickup" ตอน checkout — เฉพาะลูกค้าที่เลือกมารับเองที่โกดัง ปิดได้ถ้าไม่อยากรับเงินสด',
    fCashDays: 'ต้องมารับภายใน (วันทำการ)',
    fCashDaysHint: 'นับเฉพาะวันจันทร์–ศุกร์ ไม่นับเสาร์อาทิตย์ เช่น สั่งวันศุกร์ ใส่ 2 = ต้องมารับภายในวันอังคาร',
    // orders tab
    fltActive: 'กำลังดำเนินการ',
    fltAll: 'ทั้งหมด',
    noOrders: 'ไม่มีออเดอร์ในหมวดนี้',
    lineSummary: (s, sh, g, t) => `สินค้า ${s} + ส่ง ${sh} + GST ${g} = `,
    reportedAt: 'ลูกค้าแจ้งโอน',
    receiptView: 'ดูสลิปที่ลูกค้าแนบ',
    receiptTitle: 'สลิปโอนเงิน',
    receiptFailed: 'เปิดสลิปไม่สำเร็จ ลองใหม่อีกครั้ง',
    btnConfirmPaid: '✓ ยืนยันรับเงินแล้ว',
    btnFulfilled: '✓ ส่งมอบแล้ว',
    btnSendInvoice: '🧾 ส่งใบกำกับภาษี',
    btnResendInvoice: '🧾 ส่งใบกำกับภาษีอีกครั้ง',
    invoiceSending: 'กำลังส่ง…',
    invoiceSent: (to) => `✓ ส่งใบกำกับภาษีไปที่ ${to} แล้ว`,
    confirmResendInvoice: (to) => `ส่งใบกำกับภาษีของออเดอร์นี้ไปที่ ${to}?`,
    btnCancel: 'ยกเลิกออเดอร์',
    btnRestore: 'กู้คืนออเดอร์',
    confirmCancel: 'ยกเลิกออเดอร์นี้?',
    // products tab
    searchPlaceholder: 'ค้นหาชื่อหรือ SKU…',
    btnAddProduct: '+ เพิ่มสินค้าใหม่',
    btnReorder: '↕ จัดลำดับ',
    reorderTitle: 'จัดลำดับสินค้า',
    reorderHint: 'ลากลำดับด้วยปุ่มลูกศร — บนสุดคือสินค้าที่ลูกค้าเห็นก่อน สินค้าที่อยู่หลายหมวดจะขยับในหมวดอื่นด้วย (ใช้เลขลำดับเดียวกันทั้งเว็บ)',
    reorderPick: 'เลือกหมวด',
    reorderSave: 'บันทึกลำดับ',
    reorderSaved: 'บันทึกลำดับแล้ว',
    reorderUp: 'เลื่อนขึ้น',
    reorderDown: 'เลื่อนลง',
    reorderEmpty: 'ยังไม่มีสินค้าในหมวดนี้',
    btnBackToList: '← กลับไปหน้ารายการ',
    noImage: 'ไม่มีรูป',
    imageMissing: 'ไฟล์รูปหาย — อัปโหลดใหม่',
    hidden: '❌ ซ่อนอยู่',
    noPrice: 'ยังไม่ตั้งราคา',
    nVariants: (n) => `${n} ตัวเลือก`,
    // editor
    back: '← กลับ',
    editPrefix: 'แก้ไข:',
    newProduct: 'เพิ่มสินค้าใหม่',
    secInfo: 'ข้อมูลสินค้า',
    fSku: 'SKU (รหัสสินค้า) *',
    fSkuPh: 'เช่น SS-2PA',
    fCategory: 'หมวดหมู่หลัก',
    fExtraCategories: 'โชว์ในหมวดอื่นด้วย (เลือกได้หลายหมวด)',
    extraCategoriesHint: 'สินค้าจะขึ้นในหน้าหมวดที่ติ๊กไว้ทุกหมวด · หมวดหลักคือหมวดที่ใช้โชว์บนการ์ดและ breadcrumb',
    fName: 'ชื่อสินค้า (ภาษาอังกฤษ — โชว์หน้าเว็บ) *',
    fSubcategory: 'หมวดย่อย',
    fSubcategoryPh: 'เช่น Sliding Systems',
    fShortDesc: 'คำอธิบายสั้น (โชว์บนการ์ดและหัวหน้าเพจ)',
    fDescription: 'รายละเอียดเต็ม',
    fPrice: 'ราคา (AUD ยังไม่รวม GST)',
    fSalePrice: 'ราคาลด (เว้นว่าง = ไม่ลด)',
    fPriceOnRequest: '📞 ไม่โชว์ราคา — ให้ลูกค้าโทร/ติดต่อมาถามราคา',
    priceOnRequestHint: 'ติ๊กช่องนี้แล้วหน้าเว็บจะขึ้น "Contact us for a price" พร้อมปุ่มโทรและปุ่มส่งข้อความ แทนราคาและปุ่มใส่ตะกร้า · เหมาะกับสินค้าสั่งทำ/ราคาตามหน้างาน',
    priceOnRequestBadge: '📞 โทรถามราคา',
    fFeatured: 'สินค้าแนะนำ (โชว์หน้าแรก)',
    fPublished: 'เผยแพร่บนเว็บ',
    secImages: (n) => `รูปสินค้า (${n})`,
    btnUpload: '+ อัปโหลดรูป (รับไฟล์ถึง 100MB — ย่อให้อัตโนมัติ)',
    urlPlaceholder: 'หรือวางลิงก์รูป เช่น /images/products/…',
    btnAddUrl: 'เพิ่ม',
    del: 'ลบ',
    fImgFocus: 'ส่วนของรูปที่โชว์เวลารูปถูกครอบตัด (รูปไม่พอดีกรอบ)',
    focusDefault: 'โชว์กลางรูป (ปกติ)',
    focusTop: 'โชว์ด้านบน',
    focusBottom: 'โชว์ด้านล่าง',
    focusLeft: 'โชว์ด้านซ้าย',
    focusRight: 'โชว์ด้านขวา',
    imgOptionTag: 'รูปนี้แทนตัวเลือกไหน — พอลูกค้าเลือกค่านั้น รูปจะสลับมาโชว์รูปนี้',
    imgOptionNone: 'ไม่ผูกกับตัวเลือก',
    imgStepTag: 'รูปนี้ใช้กับขั้นตอนไหน — พอลูกค้าเปิดขั้นตอนนั้น รูปจะสลับมาโชว์รูปนี้ (เช่น รูปบอกว่าบานไหนคือบานฟิกซ์)',
    imgStepNone: 'ไม่ผูกกับขั้นตอน',
    secRelated: (n) => `สินค้าแนะนำคู่กัน (${n})`,
    relatedHint: 'สินค้าที่จะโชว์ท้ายหน้ารายละเอียดของสินค้านี้ ใต้หัวข้อ "Goes well with" · เว้นว่างไว้ได้ — ระบบจะแนะนำอุปกรณ์ที่ใช้คู่กันให้เอง (เช่น จออาบน้ำ → ชุดอุปกรณ์/ซีล/ซิลิโคน)',
    relatedSearchPh: 'พิมพ์ชื่อหรือ SKU เพื่อค้นหาสินค้าที่จะเพิ่ม…',
    relatedMissing: '(ไม่พบสินค้านี้แล้ว)',
    // options (ชนิดของตัวเลือก เช่น สี / ความกว้าง)
    secOptions: (n) => `ชนิดตัวเลือก (${n})`,
    optionsHint: 'กำหนดได้ว่าสินค้านี้ให้ลูกค้าเลือกอะไรบ้าง เช่น Hardware Colour + Width (mm) + Height (mm) — ลูกค้าจะเลือกทีละขั้นตามลำดับด้านล่างนี้ (ใส่ (mm) ท้ายชื่อ เว็บจะเติมหน่วย mm ให้เอง)',
    fOptionName: 'ชื่อตัวเลือก (ภาษาอังกฤษ — โชว์หน้าเว็บ)',
    fOptionNamePh: 'เช่น Width (mm)',
    fOptionValues: 'ค่าที่เลือกได้ (คั่นด้วยจุลภาค ,)',
    fOptionValuesPh: 'เช่น 700, 800, 900, 1000',
    moveUp: 'เลื่อนขึ้น',
    moveDown: 'เลื่อนลง',
    presetLabel: 'เพิ่มด่วน:',
    btnAddOption: '+ เพิ่มชนิดตัวเลือก',
    btnGenerate: '⚙️ สร้างตารางราคาทุกแบบผสม',
    generateHint: 'ปุ่มนี้จะสร้างแถวราคาให้ครบทุกคู่ผสมของค่าที่กรอกไว้ (เช่น 6 สี × 4 ความกว้าง = 24 แถว) แถวที่มีอยู่แล้วจะเก็บราคาเดิมไว้ — ที่เหลือแค่กรอกราคา',
    needOptionValues: 'กรุณากรอกชื่อและค่าของตัวเลือกอย่างน้อย 1 ชนิดก่อน',
    needOptionName: 'มีตัวเลือกที่กรอกค่าไว้แต่ยังไม่ได้ตั้งชื่อ',
    dupOptionName: 'ชื่อตัวเลือกซ้ำกัน — ต้องไม่ซ้ำ',
    blankOptionCell: (row) => `ตารางราคาแถวที่ ${row} ยังมีช่องตัวเลือกว่างอยู่ — กรอกให้ครบทุกช่อง`,
    blankPriceRow: (row) => `ตารางราคาแถวที่ ${row} ยังไม่ได้กรอกราคา — กรอกราคาให้ครบทุกแถวก่อนบันทึก`,
    blankIdRow: (row) => `ตารางราคาแถวที่ ${row} ยังไม่มีรหัส — กรอกรหัสให้ครบทุกแถว`,
    dupVariationId: (id) => `รหัส "${id}" ซ้ำกันในตารางราคา — รหัสแต่ละแถวต้องไม่ซ้ำ`,
    dupCombination: (row) => `ตารางราคาแถวที่ ${row} มีคู่ตัวเลือกซ้ำกับแถวก่อนหน้า — ลบหรือแก้แถวใดแถวหนึ่ง`,
    tooManyCombos: (n) => `คู่ผสมมากเกินไป (${n} แบบ) — ลดจำนวนค่าลงหน่อย หรือเปิด "ราคาบวกตามชิ้นส่วน" ด้านล่าง`,
    fStockSource: 'ตัดสต็อกจากสินค้า (เลือกสินค้าจริงในหมวด 10mm Frameless Glass Panels / Hardware)',
    stockSourceNone: 'ไม่ตัดสต็อกจากสินค้าอื่น',
    addUpToggle: 'ราคาบวกตามชิ้นส่วน (สินค้าประกอบหลายชิ้น เช่น จอกั้นอาบที่เลือกขนาดทีละบาน)',
    addUpHint: 'ราคา = ราคาตั้งต้นของสินค้า (ช่อง "ราคา" ด้านบน) + ราคาของชิ้นส่วนที่ลูกค้าเลือก · ใส่ราคาต่อค่าในช่อง "ค่าที่เลือกได้" แบบ ค่า=ราคา คั่นด้วยจุลภาค เช่น 800=120, 850=130, ไม่เอา=0 · ค่าที่ราคา 0 จะโชว์ว่า "included" · แบบนี้ไม่ต้องสร้างตารางคู่ผสม (5 ชิ้นส่วน = เกือบล้านแถว)',
    confirmAddUp: (n) => `เปลี่ยนเป็นราคาบวกตามชิ้นส่วนจะลบตารางราคาคู่ผสมทั้ง ${n} แถวของสินค้านี้ (ราคาจะมาจากราคาต่อชิ้นส่วนแทน) — ยืนยันไหม?`,
    generated: (n) => `✓ สร้างตารางราคา ${n} แถวแล้ว — กรอกราคาแล้วกดบันทึก`,
    confirmGenerate: (kept, dropped) => `จะได้ตารางราคา ${kept} แถว และแทนที่แถวเดิม ${dropped} แถวที่ไม่ตรงกับตัวเลือกใหม่ (ราคาเดิมจะถูกคัดลอกไปยังแถวใหม่ที่ใกล้เคียงที่สุด) ดำเนินการต่อ?`,
    confirmRemoveOption: (name) => `ลบตัวเลือก "${name}" ออกจากทุกแถวราคา?`,
    secVariations: (n) => `ตัวเลือกและราคา (${n})`,
    simplePriceHint: 'สินค้านี้เป็นราคาเดียว — ตั้งราคาในช่องด้านซ้าย หรือกด "เพิ่มตัวเลือก" ถ้ามีหลายแบบ (เช่น สี/ความสูง)',
    thCode: 'รหัส',
    thPrice: 'ราคา',
    thSale: 'ราคาลด',
    thStock: 'ขาย',
    thStockQty: 'สต็อก',
    fStock: 'สต็อก (เว้นว่าง = ไม่นับสต็อก)',
    stockHint: 'สต็อกจะถูกหักอัตโนมัติเมื่อมีออเดอร์ และคืนเมื่อยกเลิกออเดอร์ · เหลือ 0 = ขึ้น "หมด" บนเว็บ',
    btnAddVariation: '+ เพิ่มตัวเลือก',
    optionDefault: 'ตัวเลือก',
    btnSaveProduct: '💾 บันทึกสินค้า',
    btnCancelEdit: 'ยกเลิก',
    btnDeleteProduct: 'ลบสินค้า',
    saving: 'กำลังบันทึก…',
    uploading: 'กำลังอัปโหลดรูป…',
    uploadFailed: 'อัปโหลดไม่สำเร็จ',
    saveFailed: 'บันทึกไม่สำเร็จ',
    needSkuName: 'กรุณากรอก SKU และชื่อสินค้า',
    confirmDelete: (name) => `ลบสินค้า "${name}" ถาวร?`,
    // settings
    secBank: 'บัญชีรับเงิน (โชว์ให้ลูกค้าหลังสั่งซื้อ)',
    fAccountName: 'ชื่อบัญชี',
    fBank: 'ธนาคาร',
    fBankPh: 'เช่น Commonwealth Bank',
    fBsb: 'BSB',
    fAccountNumber: 'เลขบัญชี',
    fPayid: 'PayID (ถ้ามี)',
    bankHint: 'ถ้ายังไม่กรอกเลขบัญชี หน้าออเดอร์จะบอกให้ลูกค้าโทรมาจ่ายแทน',
    secEmail: 'อีเมลแจ้งเตือนร้าน',
    fNotifyEmails: 'อีเมลที่จะรับแจ้งเตือนออเดอร์',
    emailHint: 'ใส่ได้หลายอีเมล คั่นด้วยเครื่องหมายจุลภาค (,) — จะได้รับอีเมลทุกครั้งที่มีออเดอร์ใหม่และเมื่อลูกค้าแจ้งโอน ส่วนใบกำกับภาษีจะส่งให้ลูกค้าอัตโนมัติเมื่อยืนยันรับเงินแล้ว',
    fEmailFrom: 'ที่อยู่ผู้ส่ง (From) ของอีเมลร้าน',
    emailFromHint: 'เว้นว่าง = ใช้ค่าเริ่มต้นของระบบ (onboarding@resend.dev ซึ่งส่งได้แค่อีเมลเจ้าของบัญชี Resend) · หลังยืนยันโดเมนใน Resend แล้วให้ใส่แบบนี้: Level Up Glass Supply <orders@levelupglasssupply.com.au> แล้วลูกค้าจริงจะได้รับใบกำกับภาษี',
    fTestEmail: 'ส่งใบกำกับภาษีตัวอย่างไปที่',
    btnTestEmail: '✉️ ส่งอีเมลทดสอบ',
    testEmailSending: 'กำลังส่ง…',
    testEmailSent: (to) => `✓ ส่งแล้ว — เช็คกล่องจดหมายของ ${to} (ดูในโฟลเดอร์สแปมด้วย)`,
    secCategories: 'รูปหมวดหมู่ (การ์ดหน้าแรก)',
    catUpload: 'อัปโหลดรูป',
    catReset: 'ใช้รูปเดิม',
    catHint: 'รูปจะถูกย่อขนาดอัตโนมัติ อัปโหลดเสร็จอย่าลืมกดบันทึกการตั้งค่าด้านล่าง',
    secShipping: 'ค่าจัดส่ง (AUD ต่อออเดอร์ ยังไม่รวม GST)',
    fDelivery: 'ค่าส่งในรัศมี 50 กม. จากโกดัง (เฉพาะ Victoria)',
    shippingHint: 'รับเองที่โกดัง = ฟรีเสมอ · จัดส่งเฉพาะที่อยู่ในรัศมี 50 กม. จาก Ravenhall',
    saved: '✓ บันทึกแล้ว',
    btnSaveSettings: '💾 บันทึกการตั้งค่า',
    // ผู้ใช้หลังบ้าน
    tabUsers: 'ผู้ใช้',
    loginEmail: 'อีเมล',
    loginPasswordUser: 'รหัสผ่าน',
    loginUseMaster: 'เข้าด้วยรหัสหลักของร้าน (ADMIN_KEY)',
    loginUseAccount: '← เข้าด้วยอีเมลและรหัสผ่าน',
    loginWrongUser: 'อีเมลหรือรหัสผ่านไม่ถูกต้อง',
    loggedInAs: (n) => `เข้าใช้งานเป็น ${n}`,
    roleOwner: 'เจ้าของร้าน',
    roleStaff: 'พนักงาน',
    usersTitle: 'ผู้ใช้หลังบ้าน',
    usersHint: 'แต่ละคนเข้าระบบด้วยอีเมลและรหัสผ่านของตัวเอง ระบบจะบันทึกว่าใครดูแลลูกค้าคนไหนและทำอะไรกับออเดอร์บ้าง · "เจ้าของร้าน" เพิ่ม/ลบผู้ใช้ได้ "พนักงาน" ทำได้แค่งานประจำวัน',
    usersMasterHint: 'ตอนนี้เข้ามาด้วยรหัสหลักของร้าน (ADMIN_KEY) — สร้างบัญชีเจ้าของร้านให้ตัวเองสักบัญชี แล้วใช้บัญชีนั้นเข้าระบบแทน จะได้เห็นชื่อในประวัติการทำงาน',
    btnAddUser: '+ เพิ่มผู้ใช้',
    fUserName: 'ชื่อที่จะโชว์',
    fUserEmail: 'อีเมล',
    fUserPassword: 'รหัสผ่าน (อย่างน้อย 8 ตัวอักษร)',
    fUserRole: 'สิทธิ์',
    userActive: 'เปิดใช้งาน',
    userDisabled: 'ปิดใช้งาน',
    userNever: 'ยังไม่เคยเข้าระบบ',
    userLastLogin: (d) => `เข้าระบบล่าสุด ${d}`,
    btnSaveUser: '💾 บันทึก',
    btnResetPassword: '🔑 ตั้งรหัสผ่านใหม่',
    btnChangeMyPassword: '🔑 เปลี่ยนรหัสผ่านของฉัน',
    fCurrentPassword: 'รหัสผ่านเดิม',
    fNewPassword: 'รหัสผ่านใหม่',
    passwordChanged: '✓ เปลี่ยนรหัสผ่านแล้ว',
    passwordChangedSelf: '✓ เปลี่ยนรหัสผ่านแล้ว — กรุณาเข้าระบบใหม่',
    btnDeleteUser: 'ลบผู้ใช้',
    confirmDeleteUser: (n) => `ลบผู้ใช้ ${n}? ประวัติการทำงานที่ผ่านมายังอยู่ครบ`,
    noUsers: 'ยังไม่มีผู้ใช้ — กด "เพิ่มผู้ใช้" เพื่อสร้างบัญชีแรก',
    // ผู้ดูแลออเดอร์
    handledBy: 'ผู้ดูแล',
    handledByNone: 'ยังไม่มีผู้ดูแล',
    assignToMe: 'รับดูแลเอง',
    assignNobody: '— ยังไม่มีผู้ดูแล —',
    fltMine: 'ที่ฉันดูแล',
    historyShow: '🕘 ประวัติการจัดการ',
    historyHide: 'ซ่อนประวัติ',
    historyEmpty: 'ยังไม่มีประวัติสำหรับออเดอร์นี้',
    actStatus: 'เปลี่ยนสถานะ',
    actAssign: 'มอบหมายผู้ดูแล',
    actInvoice: 'ส่งใบกำกับภาษี',
    dateLocale: 'th-TH',
  },
  en: {
    loginTitle: 'Level Up Glass Supply — Admin',
    loginPassword: 'Password (ADMIN_KEY)',
    loginWrong: 'Incorrect password',
    loginButton: 'Log in',
    logout: 'Log out',
    tabOrders: 'Orders',
    tabProducts: 'Products',
    tabSettings: 'Store settings',
    loading: 'Loading…',
    stAwaiting: 'Awaiting payment',
    stReview: 'Transfer reported — needs checking',
    stPaid: 'Payment received',
    stFulfilled: 'Fulfilled',
    stCancelled: 'Cancelled',
    dvPickup: 'Pickup (Ravenhall)',
    dvDelivery: 'Delivery (50 km radius)',
    pmCard: '💳 Card (Stripe)',
    pmBank: '🏦 Bank transfer',
    pmCash: '💵 Cash on pickup',
    pickupBy: (d) => `Customer must collect by ${d}`,
    pickupLate: 'Pickup overdue',
    fCashEnabled: 'Offer cash on pickup',
    fCashEnabledHint: 'Shows a "Cash on pickup" choice at checkout, for warehouse pickup only. Turn it off if you would rather not take cash.',
    fCashDays: 'Collect within (business days)',
    fCashDaysHint: 'Weekends are skipped — an order placed Friday with 2 days here is due the following Tuesday.',
    fltActive: 'In progress',
    fltAll: 'All',
    noOrders: 'No orders in this view',
    lineSummary: (s, sh, g, t) => `Items ${s} + shipping ${sh} + GST ${g} = `,
    reportedAt: 'Transfer reported',
    receiptView: 'View transfer receipt',
    receiptTitle: 'Transfer receipt',
    receiptFailed: "Couldn't open the receipt — please try again",
    btnConfirmPaid: '✓ Confirm payment received',
    btnFulfilled: '✓ Mark fulfilled',
    btnSendInvoice: '🧾 Send tax invoice',
    btnResendInvoice: '🧾 Re-send tax invoice',
    invoiceSending: 'Sending…',
    invoiceSent: (to) => `✓ Tax invoice sent to ${to}`,
    confirmResendInvoice: (to) => `Send this order's tax invoice to ${to}?`,
    btnCancel: 'Cancel order',
    btnRestore: 'Restore order',
    confirmCancel: 'Cancel this order?',
    searchPlaceholder: 'Search name or SKU…',
    btnAddProduct: '+ Add product',
    btnReorder: '↕ Reorder',
    reorderTitle: 'Product order',
    reorderHint: 'Move items with the arrows — the top one is what customers see first. A product that sits in several categories moves in those too (one sort number is shared site-wide).',
    reorderPick: 'Category',
    reorderSave: 'Save order',
    reorderSaved: 'Order saved',
    reorderUp: 'Move up',
    reorderDown: 'Move down',
    reorderEmpty: 'No products in this category yet',
    btnBackToList: '← Back to the list',
    noImage: 'No photo',
    imageMissing: 'Photo file missing — upload again',
    hidden: '❌ hidden',
    noPrice: 'No price set',
    nVariants: (n) => `${n} variants`,
    back: '← Back',
    editPrefix: 'Edit:',
    newProduct: 'Add new product',
    secInfo: 'Product details',
    fSku: 'SKU (product code) *',
    fSkuPh: 'e.g. SS-2PA',
    fCategory: 'Main category',
    fExtraCategories: 'Also show in these categories',
    extraCategoriesHint: 'The product appears on every category page you tick · the main category is the one shown on cards and breadcrumbs.',
    fName: 'Product name (shown on the website) *',
    fSubcategory: 'Subcategory',
    fSubcategoryPh: 'e.g. Sliding Systems',
    fShortDesc: 'Short description (shown on cards and page header)',
    fDescription: 'Full description',
    fPrice: 'Price (AUD ex GST)',
    fSalePrice: 'Sale price (blank = no sale)',
    fPriceOnRequest: '📞 Hide the price — customers call or message for a quote',
    priceOnRequestHint: 'The website shows "Contact us for a price" with a call button and a message button instead of a price and the add-to-cart button · good for made-to-measure or on-site quoting.',
    priceOnRequestBadge: '📞 Price on request',
    fFeatured: 'Featured (shown on homepage)',
    fPublished: 'Published on website',
    secImages: (n) => `Photos (${n})`,
    btnUpload: '+ Upload photo (files up to 100MB — resized automatically)',
    urlPlaceholder: 'Or paste an image link, e.g. /images/products/…',
    btnAddUrl: 'Add',
    del: 'Delete',
    fImgFocus: 'Which part of the photo stays visible when the frame crops it',
    focusDefault: 'Show centre (default)',
    focusTop: 'Show top',
    focusBottom: 'Show bottom',
    focusLeft: 'Show left',
    focusRight: 'Show right',
    imgOptionTag: 'Which option value this photo represents — the storefront shows it when the customer picks that value',
    imgOptionNone: 'Not tied to an option',
    imgStepTag: 'Which step this photo illustrates — the storefront shows it while the customer is on that step (e.g. a diagram of which panel it means)',
    imgStepNone: 'Not tied to a step',
    secRelated: (n) => `Goes well with (${n})`,
    relatedHint: 'Products shown at the bottom of this product\'s page under "Goes well with" · Leave empty and the site suggests the parts that go with it automatically (e.g. a shower screen → hardware packages, seals, silicone).',
    relatedSearchPh: 'Search by name or SKU to add a product…',
    relatedMissing: '(no longer in the catalogue)',
    secOptions: (n) => `Option types (${n})`,
    optionsHint: 'Choose what customers pick on this product — e.g. Hardware Colour + Width (mm) + Height (mm). They pick one step at a time, in the order listed here. Adding "(mm)" to the name makes the site show values as mm.',
    fOptionName: 'Option name (shown on the website)',
    fOptionNamePh: 'e.g. Width (mm)',
    fOptionValues: 'Values (comma separated)',
    fOptionValuesPh: 'e.g. 700, 800, 900, 1000',
    moveUp: 'Move up',
    moveDown: 'Move down',
    presetLabel: 'Quick add:',
    btnAddOption: '+ Add option type',
    btnGenerate: '⚙️ Build every combination',
    generateHint: 'Creates a pricing row for every combination of the values above (e.g. 6 colours × 4 widths = 24 rows). Rows that already exist keep their price — just fill in the rest.',
    needOptionValues: 'Add a name and some values to at least one option first',
    needOptionName: 'One option has values but no name',
    dupOptionName: 'Option names must be unique',
    blankOptionCell: (row) => `Pricing row ${row} still has an empty option cell — every cell must be filled in`,
    blankPriceRow: (row) => `Pricing row ${row} has no price yet — every row needs a price before saving`,
    blankIdRow: (row) => `Pricing row ${row} has no code — every row needs one`,
    dupVariationId: (id) => `The code "${id}" is used by more than one pricing row — codes must be unique`,
    dupCombination: (row) => `Pricing row ${row} repeats the same option combination as an earlier row — remove or change one of them`,
    tooManyCombos: (n) => `That is ${n} combinations — too many. Trim some values, or switch on "Add-up pricing" below.`,
    fStockSource: 'Draw stock from (a real 10mm Frameless Glass Panels / Hardware product)',
    stockSourceNone: 'Do not draw stock from another product',
    addUpToggle: 'Add-up pricing (products built from parts — e.g. a screen sized panel by panel)',
    addUpHint: 'Price = the product\'s base price (the "Price" field above) + the price of each part the customer picks · Put a price on each value in the "Values" box as value=price, comma separated — e.g. 800=120, 850=130, None=0 · A part priced 0 shows as "included" · No combination table needed (5 parts would be almost a million rows).',
    confirmAddUp: (n) => `Switching to add-up pricing deletes this product\'s ${n} combination price rows (the price comes from the per-part prices instead) — continue?`,
    generated: (n) => `✓ Built ${n} pricing rows — add the prices, then save`,
    confirmGenerate: (kept, dropped) => `This gives ${kept} pricing rows and replaces ${dropped} existing rows that no longer match (their prices are copied to the closest new rows). Continue?`,
    confirmRemoveOption: (name) => `Remove the "${name}" option from every pricing row?`,
    secVariations: (n) => `Options & pricing (${n})`,
    simplePriceHint: 'This product has a single price — set it on the left, or click "Add variant" if it comes in multiple options (e.g. colour/height).',
    thCode: 'Code',
    thPrice: 'Price',
    thSale: 'Sale',
    thStock: 'In stock',
    thStockQty: 'Stock',
    fStock: 'Stock (blank = not tracked)',
    stockHint: 'Stock is deducted automatically when an order comes in, and returned if the order is cancelled · 0 = shows "Out of stock" on the site.',
    btnAddVariation: '+ Add variant',
    optionDefault: 'Option',
    btnSaveProduct: '💾 Save product',
    btnCancelEdit: 'Cancel',
    btnDeleteProduct: 'Delete product',
    saving: 'Saving…',
    uploading: 'Uploading photo…',
    uploadFailed: 'Upload failed',
    saveFailed: 'Save failed',
    needSkuName: 'Please enter a SKU and product name',
    confirmDelete: (name) => `Permanently delete "${name}"?`,
    secBank: 'Payment account (shown to customers after ordering)',
    fAccountName: 'Account name',
    fBank: 'Bank',
    fBankPh: 'e.g. Commonwealth Bank',
    fBsb: 'BSB',
    fAccountNumber: 'Account number',
    fPayid: 'PayID (optional)',
    bankHint: 'If no account number is set, the order page asks customers to call to arrange payment instead.',
    secEmail: 'Shop notification emails',
    fNotifyEmails: 'Send order alerts to',
    emailHint: 'Several addresses can be listed, separated by commas. These get an email for every new order and every reported transfer. Customers are emailed their tax invoice automatically once payment is confirmed.',
    fEmailFrom: 'From address for shop emails',
    emailFromHint: 'Leave empty to use the system default (onboarding@resend.dev, which only delivers to the Resend account owner) · Once the domain is verified in Resend, set it to e.g. Level Up Glass Supply <orders@levelupglasssupply.com.au> so real customers receive their tax invoice.',
    fTestEmail: 'Send a sample tax invoice to',
    btnTestEmail: '✉️ Send test email',
    testEmailSending: 'Sending…',
    testEmailSent: (to) => `✓ Sent — check the inbox for ${to} (look in spam too)`,
    secCategories: 'Category images (homepage cards)',
    catUpload: 'Upload image',
    catReset: 'Use default',
    catHint: 'Images are resized automatically. Remember to hit Save settings below after uploading.',
    secShipping: 'Shipping rates (AUD per order, ex GST)',
    fDelivery: 'Delivery within 50 km of the warehouse (Victoria only)',
    shippingHint: 'Warehouse pickup is always free · delivery only within 50 km of Ravenhall.',
    saved: '✓ Saved',
    btnSaveSettings: '💾 Save settings',
    // admin users
    tabUsers: 'Users',
    loginEmail: 'Email',
    loginPasswordUser: 'Password',
    loginUseMaster: 'Use the shop master key (ADMIN_KEY)',
    loginUseAccount: '← Log in with email and password',
    loginWrongUser: 'Email or password is incorrect',
    loggedInAs: (n) => `Signed in as ${n}`,
    roleOwner: 'Owner',
    roleStaff: 'Staff',
    usersTitle: 'Admin users',
    usersHint: 'Everyone signs in with their own email and password, so the system records who looks after which customer and what they did to each order. Owners can add and remove users; staff can only do the day-to-day work.',
    usersMasterHint: 'You are signed in with the shop master key (ADMIN_KEY). Create an owner account for yourself and use that instead, so your name shows up in the history.',
    btnAddUser: '+ Add user',
    fUserName: 'Display name',
    fUserEmail: 'Email',
    fUserPassword: 'Password (at least 8 characters)',
    fUserRole: 'Role',
    userActive: 'Active',
    userDisabled: 'Disabled',
    userNever: 'Never signed in',
    userLastLogin: (d) => `Last signed in ${d}`,
    btnSaveUser: '💾 Save',
    btnResetPassword: '🔑 Set a new password',
    btnChangeMyPassword: '🔑 Change my password',
    fCurrentPassword: 'Current password',
    fNewPassword: 'New password',
    passwordChanged: '✓ Password changed',
    passwordChangedSelf: '✓ Password changed — please log in again',
    btnDeleteUser: 'Delete user',
    confirmDeleteUser: (n) => `Delete ${n}? Everything they already did stays in the history.`,
    noUsers: 'No users yet — hit "Add user" to create the first account.',
    // order handler
    handledBy: 'Handled by',
    handledByNone: 'Nobody yet',
    assignToMe: 'Take this one',
    assignNobody: '— nobody —',
    fltMine: 'Mine',
    historyShow: '🕘 History',
    historyHide: 'Hide history',
    historyEmpty: 'Nothing recorded for this order yet',
    actStatus: 'Status change',
    actAssign: 'Assigned',
    actInvoice: 'Tax invoice',
    dateLocale: 'en-AU',
  },
}
